import { Component, OnInit , Input, forwardRef, Output, EventEmitter} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators, NG_VALUE_ACCESSOR, ControlValueAccessor, NG_VALIDATORS } from '@angular/forms';
import { PostCodeConfig } from 'src/app/model/postcodeconfig';


@Component({
  selector: 'app-postcode',
  templateUrl: './postcode.component.html',
  styleUrls: ['./postcode.component.scss'],
  providers: [
    {
      provide: NG_VALIDATORS, useExisting: PostcodeComponent, multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PostcodeComponent),
      multi: true
    }

  ]
})
export class PostcodeComponent implements OnInit, Validators, ControlValueAccessor  {
  @Input() parent: UntypedFormGroup;
  @Input() required;
  @Input() controlName: string;
  @Input() postCodeConfig: PostCodeConfig;
  @Input() pcDisabled = false;
  @Input() pageName: string;
  textValue:string;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onChangeHandler: EventEmitter<any> = new EventEmitter<any>();
  constructor(private fb: UntypedFormBuilder) {
  }
  disabled: boolean;

  onTouched: () => void;
  onChange = (value: string) => {};
  ngOnInit() {
    this.setValue();
    if (this.parent.get('ukaddressIndicator')) {
      this.parent.get('ukaddressIndicator').valueChanges.subscribe(isukres=>{
        //console.log(isukres);
        if (isukres === 'Y') {
          this.parent.get(this.controlName).setValidators([Validators.required]);
        } else {
          this.parent.get(this.controlName).clearValidators();
          this.parent.get(this.controlName).updateValueAndValidity();
        }
      });
    }
  }
  private setValue(): void {
    if (this.parent.get('ukaddressIndicator') && this.parent.get('ukaddressIndicator').value==='Y') {
      this.parent.get(this.controlName).setValidators([Validators.required]);
    } else {
      this.parent.get(this.controlName).clearValidators();
    }

   
    if(this.parent.get([this.controlName]) && this.pageName == 'beneficiaryDetails'){
      this.textValue = this.parent.get([this.controlName]).value;
    }
    else{
      this.textValue = this.postCodeConfig['defaultValue']
    }

    this.parent.get(this.controlName).setValue(this.postCodeConfig.defaultValue);
  }
  writeValue(value: any): void {
    this.postCodeConfig.defaultValue = value ? value: null;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  validate() {
    // tslint:disable-next-line: max-line-length
    const nameReForpostCode: RegExp = /^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9]|[0-9][a-zA-Z]){1}([ ])([0-9][a-zA-z][a-zA-z]){1}$/i;
    const forbidden = nameReForpostCode.test(this.parent.get(this.controlName).value);

    if (this.parent.get(this.controlName).value) {
      return forbidden ? null : { notValidPostCode: true};
      // tslint:disable-next-line:align
      } return null;
  }
  validateInput = () => {
    this.onChangeHandler.emit();
  }

  postCodeReformat(postCode) {
    if (postCode !== null) {
      const postcode = postCode.toUpperCase();
      const postcheck = postcode.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
      if (postcheck !== null) {
        postcheck.shift();
        this.parent.get(this.controlName).setValue(postcheck.join(' '));
      }
    }
  }
}
